import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faXmark, faCheckCircle, faCircle } from '@fortawesome/free-solid-svg-icons';

export interface CommonNote {
  id: string;
  text: string;
  category?: string;
}

@Component({
  selector: 'app-common-note-selector-modal',
  templateUrl: './common-note-selector-modal.component.html',
  styleUrls: ['./common-note-selector-modal.component.scss'],
  standalone: false
})
export class CommonNoteSelectorModalComponent implements OnInit {
  allNotes: CommonNote[] = [];
  filteredNotes: CommonNote[] = [];
  selectedNotes: CommonNote[] = [];
  searchText = '';

  // Icons
  faXmark = faXmark;
  faCheckCircle = faCheckCircle;
  faCircle = faCircle;

  constructor(
    public dialogRef: MatDialogRef<CommonNoteSelectorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { excludeIds: string[] }
  ) {}

  ngOnInit(): void {
    this.loadCommonNotes();
  }

  loadCommonNotes(): void {
    // Mock data for now - replace with actual service call
    this.allNotes = [
      { id: '1', text: 'Standard piping requirement for branch connections', category: 'Standard' },
      { id: '2', text: 'Welding specifications for branch table connections', category: 'Welding' },
      { id: '3', text: 'Pressure testing requirements', category: 'Testing' },
      { id: '4', text: 'Material specifications and grades', category: 'Material' },
      { id: '5', text: 'Quality control checkpoints', category: 'QC' }
    ].filter(note =>
      !this.data.excludeIds.includes(note.id)
    );
    this.filteredNotes = [...this.allNotes];
  }

  filterNotes(): void {
    const searchLower = this.searchText.toLowerCase();
    this.filteredNotes = this.allNotes.filter(note =>
      note.text.toLowerCase().includes(searchLower) ||
      (note.category && note.category.toLowerCase().includes(searchLower))
    );
  }

  toggleSelection(note: CommonNote): void {
    const index = this.selectedNotes.findIndex(n => n.id === note.id);
    if (index > -1) {
      this.selectedNotes.splice(index, 1);
    } else {
      this.selectedNotes.push(note);
    }
  }

  isSelected(noteId: string): boolean {
    return this.selectedNotes.some(n => n.id === noteId);
  }

  confirmSelection(): void {
    this.dialogRef.close(this.selectedNotes);
  }

  close(): void {
    this.dialogRef.close();
  }
}
